import Vue from 'vue';

export default [
    {
        pathId: 'mss',
        component: 'milestones',
        title: 'Reflections',
        icon: 'fa-flag-swallowtail',
        size: 'md',
        loading: true,
        reload: true
    },
    {
        pathId: 'ms',
        component: 'milestone-detail',
        title: 'Reflection Review',
        icon: 'fa-flag-swallowtail',
        size: 'lg',
        props: ['milestoneId'],
        loading: true
    },
    {
        pathId: 'msr',
        component: 'milestone-reject',
        title: 'Request Changes',
        icon: 'fa-comment-dots',
        size: 'md',
        props: ['milestoneId'],
        loading: true
    }
];

Vue.component('milestones', () => import('@/cards/milestones/Milestones'));
Vue.component('milestone-detail', () => import('@/cards/milestones/MilestoneDetail'));
Vue.component('milestone-reject', () => import('@/cards/milestones/MilestoneReject'));
